import { Routes } from '@angular/router';
import { authGuard } from './common/auth/auth.guard';
import { noAuthGuard } from './common/auth/no-auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        loadComponent: () => import('./common/auth/login/login.component').then((m) => m.LoginComponent),
        canActivate: [noAuthGuard],
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./common/auth/forgot-password/forgot-password.component').then(
            (m) => m.ForgotPasswordComponent,
          ),
        canActivate: [noAuthGuard],
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./common/auth/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent,
          ),
        canActivate: [noAuthGuard],
      },
    ],
  },
  {
    path: '',
    loadComponent: () =>
      import('./common/layout/admin-layout/admin-layout.component').then((m) => m.AdminLayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./common/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        data: { title: 'Dashboard', description: 'Panoramica incassi e iscritti' },
      },
      {
        path: 'schools',
        data: { title: 'Scuole', description: 'Anagrafica delle scuole e sedi' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./common/schools/school-list/school-list.component').then(
                (m) => m.SchoolListComponent,
              ),
          },
          {
            path: 'new',
            loadComponent: () =>
              import('./common/schools/school-form/school-form.component').then(
                (m) => m.SchoolFormComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./common/schools/school-detail/school-detail.component').then(
                (m) => m.SchoolDetailComponent,
              ),
          },
          {
            path: ':id/edit',
            loadComponent: () =>
              import('./common/schools/school-form/school-form.component').then(
                (m) => m.SchoolFormComponent,
              ),
          },
        ],
      },
      {
        path: 'children',
        data: { title: 'Bambini', description: 'Anagrafica dei bambini iscritti' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./common/children/child-list/child-list.component').then(
                (m) => m.ChildListComponent,
              ),
          },
          {
            path: 'new',
            loadComponent: () =>
              import('./common/children/child-form/child-form.component').then(
                (m) => m.ChildFormComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./common/children/child-detail/child-detail.component').then(
                (m) => m.ChildDetailComponent,
              ),
          },
          {
            path: ':id/edit',
            loadComponent: () =>
              import('./common/children/child-form/child-form.component').then(
                (m) => m.ChildFormComponent,
              ),
          },
        ],
      },
      {
        path: 'educators',
        data: { title: 'Educatori', description: 'Anagrafica degli educatori' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./common/educators/educator-list/educator-list.component').then(
                (m) => m.EducatorListComponent,
              ),
          },
          {
            path: 'new',
            loadComponent: () =>
              import('./common/educators/educator-form/educator-form.component').then(
                (m) => m.EducatorFormComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./common/educators/educator-detail/educator-detail.component').then(
                (m) => m.EducatorDetailComponent,
              ),
          },
          {
            path: ':id/edit',
            loadComponent: () =>
              import('./common/educators/educator-form/educator-form.component').then(
                (m) => m.EducatorFormComponent,
              ),
          },
        ],
      },
      {
        path: 'parents',
        data: { title: 'Genitori', description: 'Anagrafica dei genitori' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./common/parents/parent-list/parent-list.component').then(
                (m) => m.ParentListComponent,
              ),
          },
          {
            path: 'new',
            loadComponent: () =>
              import('./common/parents/parent-form/parent-form.component').then(
                (m) => m.ParentFormComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./common/parents/parent-detail/parent-detail.component').then(
                (m) => m.ParentDetailComponent,
              ),
          },
          {
            path: ':id/edit',
            loadComponent: () =>
              import('./common/parents/parent-form/parent-form.component').then(
                (m) => m.ParentFormComponent,
              ),
          },
        ],
      },
      {
        path: 'doposcuola',
        loadChildren: () => import('./doposcuola/doposcuola.routes').then((m) => m.doposcuolaRoutes),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./common/settings/settings.component').then((m) => m.SettingsComponent),
        data: { title: 'Impostazioni', description: "Profilo e sicurezza dell'account" },
      },
      {
        path: 'archivio/bambini',
        data: {
          title: 'Bambini archiviati',
          description: 'Bambini cancellati con iscrizioni, pagamenti e presenze',
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./common/archive/child-archive-list/child-archive-list.component').then(
                (m) => m.ChildArchiveListComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./common/archive/child-archive-detail/child-archive-detail.component').then(
                (m) => m.ChildArchiveDetailComponent,
              ),
          },
        ],
      },
      {
        path: 'archivio/genitori',
        data: {
          title: 'Genitori archiviati',
          description: 'Genitori archiviati insieme al loro ultimo bambino',
        },
        loadComponent: () =>
          import('./common/archive/parent-archive-list/parent-archive-list.component').then(
            (m) => m.ParentArchiveListComponent,
          ),
      },
      {
        path: 'archivio/educatori',
        data: { title: 'Educatori archiviati', description: 'Educatori cancellati con i loro compensi' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./common/archive/educator-archive-list/educator-archive-list.component').then(
                (m) => m.EducatorArchiveListComponent,
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./common/archive/educator-archive-detail/educator-archive-detail.component').then(
                (m) => m.EducatorArchiveDetailComponent,
              ),
          },
        ],
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
